/** Set at build time in Cloudflare Pages / CI (must rebuild after changing). */
export const BUILT_REACT_APP_SOCKET_URL = (process.env.REACT_APP_SOCKET_URL || "").trim();

/**
 * Only protocol + host (+ port). Strips paths like /api so /api/auth is not doubled.
 * Strips wrapping quotes from dashboard copy/paste.
 */
export function toHttpOrigin(raw) {
  if (!raw || typeof raw !== "string") return "";
  let s = raw.trim().replace(/^["']+|["']+$/g, "").trim();
  if (!s) return "";
  if (s.startsWith("ws://")) s = `http://${s.slice(5)}`;
  else if (s.startsWith("wss://")) s = `https://${s.slice(6)}`;
  if (!/^https?:\/\//i.test(s)) s = `https://${s}`;
  try {
    const u = new URL(s);
    return `${u.protocol}//${u.host}`;
  } catch {
    return "";
  }
}

/**
 * Backend HTTP + Socket.IO base URL (origin only, no trailing slash).
 */
export function getRuntimeApiBase() {
  if (typeof window === "undefined") return "";
  try {
    const override = window.localStorage.getItem("CHAT_API_BASE");
    if (override && /^https?:\/\//i.test(override)) {
      const o = toHttpOrigin(override);
      if (o) return o;
    }
  } catch {
    /* ignore */
  }
  if (BUILT_REACT_APP_SOCKET_URL) {
    const first = BUILT_REACT_APP_SOCKET_URL.split(",")[0];
    const origin = toHttpOrigin(first);
    if (origin) return origin;
  }
  const { protocol, hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//${hostname}:3001`;
  }
  return `${protocol}//${hostname}:3001`;
}
